import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { Icon } from '/imports/ui/Icon';

const BreadCrumbsStyled = styled.div`
  display: flex;
  .icon {
    position: relative;
    top: 1px;
    svg {
      width: 1rem;
    }
  }
  a {
    color: ${css.grey2};
    margin-right: 1rem;
    margin-left: 1rem;
  }
  ${css.mobileMedia} {
    display: none;
  }
`;
export interface BreadCrumb {
  path: string, label: string
}

export let setBreadcrumbs: React.Dispatch<React.SetStateAction<BreadCrumb[]>>;

/** Renders the breadcrumb trail; exposes setBreadcrumbs for pages to populate it. */
export const BreadCrumbs = () => {
  const [breadcrumbs, _setBreadcrumbs] = useState<BreadCrumb[]>([]);
  setBreadcrumbs = _setBreadcrumbs;
  return (
    <BreadCrumbsStyled className="breadcrumbs">
      {
        breadcrumbs.map((crumb) => {
          return (
            <div key={crumb.path} className="crumb">
              <Icon icon="chevronRight" />
              <Link to={crumb.path}>{crumb.label}</Link>
            </div>
          );
        })
      }
    </BreadCrumbsStyled>
  );
};
